import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  '& hr': {
    backgroundColor: '#2B3550',
    border: 'none',
    height: 1,
  },
  '& h3': {
    color: theme.palette.global.white,
    marginBottom: 32,
  },
  '& section': {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    '& h4': {
      color: theme.palette.global.white,
      fontWeight: 600,
    },
    '& .amount': {
      color: theme.palette.secondary.main,
    },
  },
  '& input': {
    backgroundColor: '#212334',
    borderRadius: 5,
    border: 'none',
    width: 370,
    color: 'lightgray',
    '&::placeholder': {
      color: 'lightgray',
    },
  },
}));
